import { render } from "./LichensCheckilstMurmansk.vue?vue&type=template&id=24a4d08a"
import script from "./LichensCheckilstMurmansk.vue?vue&type=script&lang=js"
export * from "./LichensCheckilstMurmansk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__